<pre #jsonWrapper class="json-container rounded-control p-3 my-2 text-sm" [ngClass]="{
  'bg-gray-50': !white,
  'bg-white': white,
}"></pre>
